import ArtTrackIcon from '@mui/icons-material/ArtTrack';
import cn from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'reactstrap';

interface Props {
  isDisabled?: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const AddPhotoButton = ({ isDisabled, onChange }: Props) => {
  const { t } = useTranslation();

  return (
    <Button className={cn('btn btn-secondary btn-add-img', isDisabled && 'disabled')} disabled={isDisabled}>
      <ArtTrackIcon className="camera" />

      {t('add-photo')}

      <input id="imageInput" type="file" accept="image/*" onChange={onChange} disabled={isDisabled} />
    </Button>
  );
};
